<template> 
    <div class="select-input">
        <div class="seach-type">
            <span>{{value.name}}</span> 
            <div class="seach-type-position">
                <p v-for="( item , index ) in option" :key="index" @click="optionActive(item,index)">
                    {{item.name}}
                </p> 
            </div>
        </div>
    </div> 
</template>
<script> 
export default {
  props:{
      value:{
          type:Object
      },
      option:{
          type:Array 
      }
  },
  data() {
    return { 
        input:""
    };
  },
  computed: {
  }, 
  methods: { 
      optionActive(item,index) { 
        this.$emit("click", {item,index});
      },
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">

.select-input{
    

    .seach-type{
        width: 85px;
        height: 32px;
        line-height: 32px;
        position: relative;
        padding: 0 0 0 6px;
        cursor: pointer;
        box-sizing: border-box;
        color: #f3efe7;
        background-size: cover;
        background-image: url(../../assets/seach-btnback-up.jpg);
        
        &:hover{
            background-image: url(../../assets/seach-btnback-down.jpg)
        }

        &:hover .seach-type-position{
            display: block;
        }
 
        &-position{
            position: absolute;
            top: 32px;
            left: 0;
            width: 100%;
            z-index: 9;
            border: 1px solid #5b5956;
            box-sizing: border-box;
            background: #cbc3b7;
            display: none;

            p{
                padding: 4px;
                cursor: pointer;
                color: #5b5956;
                cursor: pointer; 

                &:hover{
                    background: #6a6058;
                    color: #ede9e2;
                }
            }
        }
    } 
}
</style>
